import Vue from 'vue'
import vuetify from '../vuetify'
import JsonViewer from './json-viewer'
import _ from 'lodash'

const TRANSLATE = {
  newField: 'new',
  missingField: 'missing',
  diffType: 'type',
  diffValue: 'value',
  diffAdd: 'add',
  diffDel: 'delete'
}
const _isPrimitiveArray = value => !_.some(value, o => _.isObject(o))

export { JsonViewer }
export default {
  open(params) {
    if (!params) return console.error('[$json] no params supplied!')

    const options = {options: {...params}}
    spawn(options)
  },
  close() {
  },

  parse(str) {
    try {
      return JSON.parse(str)
    } catch (e) {}
  },
  stringify(obj) {
    try {
      return JSON.stringify(obj)
    } catch (e) {
      console.dir(obj)
    }
  },

  compare(_obj1, _obj2, _Q = [], cSkip) {
    if (!_obj1 || !_obj2) return _Q

    const cmp = !_.isArray(_Q) ? [] : _Q
    const objIsArray = _.isArray(_obj2)

    // if both objects are array and have only primitive values
    // or object 1 is empty (this way no _.each(obj1) is done)
    // we simple check difference between these 2 arrays
    if (_.isArray(_obj1) && _.isArray(_obj2)) {
      if (_.isEmpty(_obj1) || (_isPrimitiveArray(_obj1) && _isPrimitiveArray(_obj2))) {
        const diffAdd = _.differenceWith(_obj2, _obj1, _.isEqual)
        const diffDel = _.differenceWith(_obj1, _obj2, _.isEqual)
        if (!_.isEmpty(diffAdd)) cmp.push({ type: TRANSLATE.diffAdd, diff: diffAdd })
        if (!_.isEmpty(diffDel)) cmp.push({ type: TRANSLATE.diffDel, diff: diffDel })
        return cmp
      }
    }

    const obj1 = _.cloneDeep(_obj1)
    const newO2 = _.cloneDeep(_obj2)

    _.each(obj1, (value1, key) => {
      if (skip(key)) return

      const value2 = _obj2[key]
      // only remove keys in objects
      if (!objIsArray) delete newO2[key]

      const typeofValue1 = typeof value1
      const typeofValue2 = typeof value2

      if (typeofValue1 !== typeofValue2 && typeofValue2 === 'undefined') {
        cmp.push({ type: TRANSLATE.missingField, key, old: value1, new: value2 })
      }
      else if (typeofValue1 !== typeofValue2) {
        cmp.push([TRANSLATE.diffType, key, value1, value2, obj1])
      }
      else {
        if (_.isArray(value1) && _.isArray(value2)) {
          if (_isPrimitiveArray(value1) && _isPrimitiveArray(value2)) {
            const diffAdd = _.differenceWith(value2, value1, _.isEqual)
            const diffDel = _.differenceWith(value1, value2, _.isEqual)
            if (!_.isEmpty(diffAdd)) cmp.push({ type: TRANSLATE.diffAdd, diff: diffAdd })
            if (!_.isEmpty(diffDel)) cmp.push({ type: TRANSLATE.diffDel, diff: diffDel })
          }
          else this.compare(value1, value2, cmp, cSkip)
        }
        // For jQuery objects
        else if (value1 && value1.length && (typeof value1[0] !== 'undefined' && value1[0].tagName)) {
          if (!value2 || value2.length !== value1.length || !value2[0].tagName || value2[0].tagName !== value1[0].tagName) {
            cmp.push(['diffJqueryObj', key, value1, value2, obj1])
          }
        }
        else if (value1 && value1.length && (value1.tagName !== value2.tagName)) {
          cmp.push(['diffHtmlObj', key, value1, value2, obj1])
        }
        else if (typeofValue1 === 'function' || typeofValue2 === 'function') {
          cmp.push(['function', key, value1, value2, obj1])
        }
        else if (typeofValue1 === 'object') {
          this.compare(value1, value2, cmp, cSkip)
        }
        else if (value1 !== value2) {
          cmp.push({ type: TRANSLATE.diffValue, key, old: value1, new: value2 })
        }
      }
    })

    // for objects all keys left are new
    if (!objIsArray) {
      _.each(newO2, (o2, key) => {
        if (o2 && !skip(key)) {
          cmp.push({ type: TRANSLATE.newField, key, old: obj1[key], new: o2 })
        }
      })
    }
    // if obj1 is an array, but has less items
    // the _.each(obj1) has not detect the difference
    // add the new items to cmp list
    else if (_.size(_obj1) < _.size(_obj2)) {
      const diffAdd = _.differenceWith(_obj2, _obj1, _.isEqual)
      if (!_.isEmpty(diffAdd)) cmp.push({ type: TRANSLATE.diffAdd, diff: diffAdd })
    }

    return cmp

    function skip(key) {
      if (!cSkip) return false // no fields to skip defined
      return cSkip.indexOf(`:${key}:`) !== -1
    }
  },

  save(data, filename = 'vue-json.json') {
    if (_.isEmpty(data)) return

    data = JSON.stringify(data, null, 4)
    const blob = new Blob([data], { type: 'text/json' })
    const event = document.createEvent('MouseEvents')
    const anchor = document.createElement('a')
    anchor.download = filename
    anchor.href = window.URL.createObjectURL(blob)
    anchor.dataset.downloadurl = ['text/json', anchor.download, anchor.href].join(':')
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    anchor.dispatchEvent(event)
  },

  testCompare() {
    let testCount = 0
    let testFailed = 0

    // 2 objects: 1 property (type: number) changed
    testCount++
    const oa1 = {a: 1}
    const on1 = {a: 2}
    const cmp1 = this.compare(oa1, on1)
    const exp1 = [{type: 'value', key: 'a', old: 1, new: 2}]
    if (!_.isEqual(cmp1, exp1)) {
      testFailed++
      console.error('T1: failed: #value', JSON.stringify(cmp1), 'expected:', JSON.stringify(exp1))
    }

    // 2 objects: 1 property (type: string) changed
    testCount++
    const oa2 = {a: 'test'}
    const on2 = {a: 'TEST'}
    const cmp2 = this.compare(oa2, on2)
    const exp2 = [{type: 'value', key: 'a', old: 'test', new: 'TEST'}]
    if (!_.isEqual(cmp2, exp2)) {
      testFailed++
      console.error('T2: failed: #value', cmp2, 'expected:', exp2)
    }

    // 2 objects: test skipping property
    testCount++
    const oa3 = {name: 'name', sub: {collapsed: false}}
    const on3 = {name: 'name', sub: {collapsed: true}}
    const cmp3 = this.compare(oa3, on3, [], ':collapsed:')
    if (!_.isEmpty(cmp3)) {
      testFailed++
      console.error('T3: failed: #value', cmp3, 'expected: []')
    }

    testCount++
    const ex4 = [{type: TRANSLATE.diffAdd, diff: ['1']}]
    const cmp4 = this.compare([], ['1'])
    if (!_.isEqual(cmp4, ex4)) {
      testFailed++
      console.error('T4: failed: #value', JSON.stringify(cmp4), 'expected: ', JSON.stringify(ex4))
    }

    testCount++
    const ex5 = [{type: TRANSLATE.diffDel, diff: ['1']}]
    const cmp5 = this.compare(['1'], [])
    if (!_.isEqual(cmp5, ex5)) {
      testFailed++
      console.error('T5: failed: #value', JSON.stringify(cmp5), 'expected: ', JSON.stringify(ex5))
    }

    // two empty arrays
    testCount++
    const cmp6 = this.compare([], [])
    if (!_.isEmpty(cmp6)) {
      testFailed++
      console.error('T6: failed: #value', cmp6, 'expected: []')
    }

    // new object is added in array
    testCount++
    const ex7 = [{type: 'add', diff: [{value: 1}]}]
    const cmp7 = this.compare([], [{value: 1}])
    if (!_.isEqual(cmp7, ex7)) {
      testFailed++
      console.error('T7: failed: #value', JSON.stringify(cmp7), 'expected: ', JSON.stringify(ex7))
    }

    testCount++
    const oa8 = [{value: 1}]
    const on8 = [{value: 2}]
    const ex8 = [{type: 'value', key: 'value', old: 1, new: 2}]
    const cmp8 = this.compare(oa8, on8)
    if (!_.isEqual(cmp8, ex8)) {
      testFailed++
      console.debug('TEST 8')
      console.debug('compare: ', JSON.stringify(oa8), 'with', JSON.stringify(on8))
      console.debug('%cFAILED', 'color:red')
      console.debug('result : ', JSON.stringify(cmp8))
      console.debug('expect : ', JSON.stringify(ex8))
    }

    // 2 arrays with objects, two objects were added
    testCount++
    const oa9 = [{value: 1}]
    const on9 = [{value: 1}, {value: 2}, {value: 3}]
    const ex9 = [{type: 'add', diff: [{value: 2}, {value: 3}]}]
    const cmp9 = this.compare(oa9, on9)
    if (!_.isEqual(cmp9, ex9)) {
      testFailed++
      console.debug('TEST 9')
      console.debug('compare: ', JSON.stringify(oa9), 'with', JSON.stringify(on9))
      console.debug('%cFAILED', 'color:red')
      console.debug('result : ', JSON.stringify(cmp9))
      console.debug('expect : ', JSON.stringify(ex9))
    }

    // 2 arrays with objects, one objects was deleted
    testCount++
    const oa10 = [{value: 1}, {value: 2}]
    const on10 = [{value: 1}]
    const ex10 = [{type: 'missing', key: 1, new: undefined, old: {value: 2}}]
    const cmp10 = this.compare(oa10, on10)
    if (!_.isEqual(cmp10, ex10)) {
      testFailed++
      console.debug('TEST 10')
      console.debug('compare: ', JSON.stringify(oa10), 'with', JSON.stringify(on10))
      console.debug('%cFAILED', 'color:red')
      console.debug('result : ', JSON.stringify(cmp10))
      console.debug('expect : ', JSON.stringify(ex10))
    }

    return {testCount, testFailed}
  }
}

function spawn(propsData) {
  // const id = 'v-json-viewer'
  // const $el = document.querySelector(`#${id}`)
  // console.log('$el', $el)
  // if ($el) $el.parentNode.removeChild($el)

  const JVComponent = Vue.extend(JsonViewer)
  new JVComponent({
    el: document.createElement('div'),
    propsData,
    vuetify,
    onMounted(el) {
    },
    onClose() {
    },
    onAction() {
      propsData.actionHandler()
    }
  })
}
